export interface EventArgs {
  type: string;
  description?: string;
  pageName?: string;
  delay?: number;
}


export class AnalyticsEvent {
  readonly type: string;
  readonly description: string;
  readonly pageName: string;
  readonly delay: number;

  constructor(args: EventArgs) {
    this.type = args.type;
    this.description = args.description;
    this.pageName = args.pageName;
    this.delay = typeof args.delay === 'number' ? args.delay : 0;
  }
}
